export const FORM_FIELD = {
  CAMPAIGN: {
    name: 'campaign',
    rules: [{ required: true, message: 'Campaign is required' }],
  },
};

export const TYPE = 'CTA';

export const BUTTON = {
  type: TYPE,
  tooltip: 'add CTA link',
  icon: 'CTA',
};
